export const GA_MEASUREMENT_ID = "G-67G1PE0H07";

export function trackPageView({ pathname, search, hash }) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${pathname}${search}${hash}`,
  });
}

export function trackEvent(name, parameters = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  window.gtag("event", name, parameters);
}
